import { Component, EventEmitter, Output } from '@angular/core';
import { BillsService } from '../../../services/bills.services';
import { AppMessageService } from '../../../../../shared/services/app-message/app-message.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-bill-document-email',
  templateUrl: './send-bill-document-email.component.html',
  styleUrl: './send-bill-document-email.component.scss',
})
export class SendBillDocumentEmailComponent {
  @Output() clearOn = new EventEmitter();
  selectedEmails: string[] = [];
  popup: boolean = false;
  billEmail: string | null;
  billId: number | null;

  constructor(
    private readonly billService: BillsService,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService
  ) {}

  initilize(billId: number, email: string | null) {
    this.billId = billId;
    this.billEmail = email;
    this.popup = true;
  }

  clearPopup() {
    this.billId = null;
    this.selectedEmails = [];
    this.billEmail = null;
    this.clearOn.emit();
  }
  isEmailSelected(email: string): boolean {
    return this.selectedEmails.includes(email);
  }

  toggleEmail(email: string) {
    if (this.isEmailSelected(email)) {
       this.selectedEmails = this.selectedEmails.filter((p) => p !== email);
    } else {
      this.selectedEmails = [...this.selectedEmails, email];
    }
  }

  sendEmail() {
    if (!this.billId) {
      this.messageService.errorToast(
        this.translate.instant('bills.send-email.send-email-validation-id'),
        ''
      );
      return;
    }
    if (!this.selectedEmails || this.selectedEmails.length === 0) {
      this.messageService.errorToast(
        this.translate.instant('bills.send-email.send-email-validation-email'),
        ''
      );
      return;
    }
    this.billService
      .sendBillDocumentEmail(this.billId, this.selectedEmails)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.messageService.successToast(
              this.translate.instant('bills.send-email.send-email-success'),
              ''
            );
             this.popup = false;
             this.clearPopup()
          } else {
            this.messageService.errorToast(
              this.translate.instant('bills.send-email.send-email-success'),
              ''
            );
          }
        },
      });
  }

  handleChipAdd(event: any) {
    const email = event.value.trim().replaceAll(/\s+/g, ''); // boşlukları temizle
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      this.selectedEmails = this.selectedEmails.filter((e) => e !== email);
    }
  }
}
